import { Combobox } from "components/DesignSystem/Combobox/Combobox";
import { emailValidationRegex } from "constants/emailValidationRegex";
import { getIn, useFormikContext } from "formik";
import { useToast } from "hooks/useToast";
import { ReactNode, useState } from "react";

export const CustomerEmailsCombobox = ({
  name,
  label,
  note,
  isLoading,
}: {
  name: string;
  label: string;
  note?: ReactNode;
  isLoading?: boolean;
}) => {
  const { values, setFieldValue } = useFormikContext<unknown>();
  const { alertToast } = useToast();
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const emails: string[] = getIn(values, name) || [];

  const onCreateOption = (inputValue: string) => {
    const trimmedEmail = inputValue.trim();

    if (!emailValidationRegex.test(trimmedEmail)) {
      alertToast({ message: "Please enter a valid email address" });
      return;
    }

    setFieldValue(name, [...emails, trimmedEmail]);
    // Emails are free text, nothing left to pick once added
    setIsMenuOpen(false);
  };

  return (
    <Combobox
      withForm
      menuPortalTarget={document.body}
      name={name}
      label={label}
      note={note}
      placeholder="Add email addresses"
      creatable
      isMulti
      size="small"
      value={emails.map((email) => ({ value: email, label: email }))}
      isLoading={isLoading}
      menuIsOpen={isMenuOpen}
      onMenuOpen={() => setIsMenuOpen(true)}
      onMenuClose={() => setIsMenuOpen(false)}
      // No option list here, so never show the "No options" notice
      noOptionsMessage={() => null}
      onCreateOption={onCreateOption}
    />
  );
};
